// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectAssetMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_ASSET_TYPE_MESSAGE);
        this.Id = 0;
        this.Type = 0;
        this.Name = null;
        this.Description = null;
        this.MinChange = 0;
        this.RouteId = null;
        this.InstrumentId = null;
        this.CreditForSell = null;
        this.LiquidityRate = null;
        this.InstrumentTradableID = -1;
    }
}
